import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATH_SEGMENTS, route } from '../../config/paths';
import ThemePicker from './ThemePicker';
import { useMarketingTheme } from '../../contexts/MarketingThemeContext';
import './LandingHeader.css';

const LandingHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pickerEnabled } = useMarketingTheme();
  const onLanding = location.pathname === '/';
  const onDemo =
    location.pathname === '/live-demo' || location.pathname.startsWith('/live-demo/');

  const goHomeSection = (hash: string) => {
    if (onLanding) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.location.hash = hash;
      return;
    }
    navigate({ pathname: route(), hash: hash.replace('#', '') });
  };

  const handleGetStarted = () => {
    navigate(route(PATH_SEGMENTS.INTERACTIONS));
  };

  const handleLiveDemo = () => {
    navigate(route(PATH_SEGMENTS.LIVE_DEMO));
  };

  return (
    <header className="landing-header">
      <div className="landing-header-content">
        <button
          type="button"
          className="landing-logo"
          onClick={() => navigate(route())}
          aria-label="Vhearu home"
        >
          <img src="/vhu-mmt-horizontal.png" alt="Vhearu" className="landing-logo-img" />
        </button>
        <nav className="landing-nav">
          <button
            type="button"
            className={`landing-nav-link landing-nav-button ${onDemo ? 'is-active' : ''}`}
            onClick={handleLiveDemo}
          >
            Live demos
          </button>
          <button
            type="button"
            className="landing-nav-link landing-nav-button"
            onClick={() => goHomeSection('#products')}
          >
            Products
          </button>
          <button
            type="button"
            className="landing-nav-link landing-nav-button"
            onClick={() => goHomeSection('#features')}
          >
            Features
          </button>
          {pickerEnabled ? <ThemePicker /> : null}
          <button className="landing-cta-button" type="button" onClick={handleGetStarted}>
            Get Started
          </button>
        </nav>
      </div>
    </header>
  );
};

export default LandingHeader;
